import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Printer, ArrowLeft, HardHat } from "lucide-react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Skeleton } from "@/components/ui/skeleton";

export default function PrintPage() {
  const { user } = useAuth();
  const [words, setWords] = useState(null);
  useEffect(() => { api.get("/vocabulary").then((r) => setWords(r.data)); }, []);
  if (!words) return <Skeleton className="h-40 w-full" />;

  const missed = words.filter((w) => w.to_review);
  const list = missed.length ? missed : words;

  return (
    <div className="space-y-5">
      <div className="flex items-center justify-between print:hidden">
        <Link to="/vocabulaire" data-testid="print-back-btn" className="flex items-center gap-1 font-semibold text-slate-600 hover:text-slate-900">
          <ArrowLeft className="w-5 h-5" /> Mes mots
        </Link>
        <button
          onClick={() => window.print()}
          disabled={!list.length}
          data-testid="print-btn"
          className="h-12 px-5 rounded-xl bg-orange-500 hover:bg-orange-600 text-white font-bold flex items-center gap-2 transition-colors disabled:opacity-40"
        >
          <Printer className="w-5 h-5" /> Imprimer
        </button>
      </div>

      <div className="bg-white rounded-2xl border-2 border-slate-200 p-5 print:border-0 print:p-0" data-testid="print-sheet">
        <div className="flex items-center justify-between border-b-4 border-slate-900 pb-2 mb-4">
          <div className="flex items-center gap-2">
            <HardHat className="w-6 h-6 text-orange-500" />
            <span className="font-display text-2xl font-extrabold uppercase">Mes mots du chantier</span>
          </div>
          <span className="text-sm text-slate-600">{user.name} · {new Date().toLocaleDateString("fr-FR")}</span>
        </div>
        <p className="text-xs font-bold uppercase text-slate-500 mb-3" data-testid="print-subtitle">
          {missed.length ? `${missed.length} mots à revoir` : `${words.length} mots appris`}
        </p>
        {!list.length ? (
          <p className="text-slate-600" data-testid="print-empty">Aucun mot pour le moment.</p>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 print:grid-cols-2 gap-3">
            {list.map((w, i) => (
              <div key={w.word} className="border-2 border-dashed border-slate-400 rounded-lg p-3 break-inside-avoid" data-testid={`print-word-${i}`}>
                <div className="flex items-baseline justify-between gap-2">
                  <span className="font-bold text-lg">{w.word}</span>
                  <span className="text-[10px] font-bold uppercase text-orange-600">{w.theme}</span>
                </div>
                <p className="text-sm">{w.definition}</p>
                {w.example && <p className="text-xs italic text-slate-600 mt-1">« {w.example} »</p>}
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
